export interface IContractObjectSubtype {
  idContractObjectType: number;
  idContactObjectSubtype: number;
  contactObjectSubtype: string;
  allowFreeText: boolean;
}

export interface IContractObjectType {
  idContractObjectType: number;
  contractObjectType: string;
}

export const staticContractObjectTypeArray: IContractObjectType[] = [
  {
    idContractObjectType: 1,
    contractObjectType: 'Genehmigung eines Vertrags',
  },
  {
    idContractObjectType: 2,
    contractObjectType: 'Vollmachten',
  },
  {
    idContractObjectType: 3,
    contractObjectType: 'Erklärungen gegenüber Behörden und Gerichten',
  },
  {
    idContractObjectType: 4,
    contractObjectType: 'Gründung von Gesellschaften',
  },
  {
    idContractObjectType: 5,
    contractObjectType: 'Eintragungen und Löschungen im Grundbuch',
  },
  {
    idContractObjectType: 6,
    contractObjectType: 'Erbausgeschichten',
  },
  {
    idContractObjectType: 7,
    contractObjectType: 'Sonstige private oder geschäftliche Vereinbarungen',
  },
];

export const staticContractObjectSubtypeArray: IContractObjectSubtype[] = [
  {
    idContractObjectType: 1,
    idContactObjectSubtype: 1,
    contactObjectSubtype: 'Kaufverträge',
    allowFreeText: false,
  },
  {
    idContractObjectType: 1,
    idContactObjectSubtype: 2,
    contactObjectSubtype: 'Schenkungsverträge',
    allowFreeText: false,
  },
  {
    idContractObjectType: 1,
    idContactObjectSubtype: 3,
    contactObjectSubtype: 'Eheverträge',
    allowFreeText: false,
  },
  {
    idContractObjectType: 2,
    idContactObjectSubtype: 4,
    contactObjectSubtype: 'Allgemeine Vollmacht',
    allowFreeText: false,
  },
  {
    idContractObjectType: 2,
    idContactObjectSubtype: 5,
    contactObjectSubtype: 'Vorsorgevollmacht',
    allowFreeText: false,
  },
  {
    idContractObjectType: 2,
    idContactObjectSubtype: 6,
    contactObjectSubtype: 'Patientenverfügung',
    allowFreeText: false,
  },
  {
    idContractObjectType: 2,
    idContactObjectSubtype: 7,
    contactObjectSubtype: 'Bankvollmacht',
    allowFreeText: false,
  },
  {
    idContractObjectType: 2,
    idContactObjectSubtype: 8,
    contactObjectSubtype: 'Vollmacht zur Vertretung bei Behördengängen',
    allowFreeText: false,
  },
  {
    idContractObjectType: 3,
    idContactObjectSubtype: 20,
    contactObjectSubtype:
      'Einverständniserklärung für das Kind beim Auslandsaufenthalt',
    allowFreeText: false,
  },
  {
    idContractObjectType: 3,
    idContactObjectSubtype: 9,
    contactObjectSubtype:
      'Zustimmungserklärung zu einem behördlichen Antrag (z. B. Erbschaft)',
    allowFreeText: false,
  },
  {
    idContractObjectType: 4,
    idContactObjectSubtype: 10,
    contactObjectSubtype: 'Anmeldung zum Handelsregister',
    allowFreeText: false,
  },
  {
    idContractObjectType: 4,
    idContactObjectSubtype: 11,
    contactObjectSubtype:
      'Gründungsunterlagen für GmbH, UG oder andere juristische Personen',
    allowFreeText: false,
  },
  {
    idContractObjectType: 5,
    idContactObjectSubtype: 12,
    contactObjectSubtype: 'Auflassungserklärung',
    allowFreeText: false,
  },
  {
    idContractObjectType: 5,
    idContactObjectSubtype: 13,
    contactObjectSubtype: 'Zustimmung zur Löschung einer Grundschuld',
    allowFreeText: false,
  },
  {
    idContractObjectType: 6,
    idContactObjectSubtype: 14,
    contactObjectSubtype: 'Erbscheinsanträge',
    allowFreeText: false,
  },
  {
    idContractObjectType: 6,
    idContactObjectSubtype: 15,
    contactObjectSubtype: 'Ausschlagung einer Erbschaft',
    allowFreeText: false,
  },
  {
    idContractObjectType: 7,
    idContactObjectSubtype: 16,
    contactObjectSubtype: 'Mietverträge',
    allowFreeText: false,
  },
  {
    idContractObjectType: 7,
    idContactObjectSubtype: 17,
    contactObjectSubtype: 'Schuldanerkenntnisse',
    allowFreeText: false,
  },
  {
    idContractObjectType: 7,
    idContactObjectSubtype: 18,
    contactObjectSubtype: 'Bürgschaftserklärungen',
    allowFreeText: false,
  },
  {
    idContractObjectType: 7,
    idContactObjectSubtype: 19,
    contactObjectSubtype: 'Sonstiges',
    allowFreeText: true,
  },
];
